import {
  IndexableLocalizedItem,
  LocalizedValueModel,
} from '@osos/shared/types';

export function getDuplicateLocalePropName({
  items,
  name,
  id,
}: {
  items: Array<IndexableLocalizedItem>;
  name: LocalizedValueModel;
  id?: string;
}): Array<string> {
  return Object.keys(name).filter(
    (locale) =>
      !!items.find((item) => {
        const itemName = item.name?.[locale]
          ? item.name[locale].trim().toLowerCase()
          : '';
        const nameLocale = name?.[locale]
          ? name[locale].trim().toLowerCase()
          : '';
        return itemName && itemName === nameLocale && item.id !== id;
      }),
  );
}

/**
 * @description remove empty props from localizedValueModel
 * @param value
 * @returns
 */
export function removeEmptyLocalesFromLocalized(
  value: LocalizedValueModel,
): LocalizedValueModel {
  if (!value) return {};
  return Object.keys(value).reduce((acc, key) => {
    if (value[key].trim()) {
      acc[key] = value[key];
    }
    return acc;
  }, {});
}
